<template>
  <div class="main-layout yx-student-predicted-page">
    <el-card class="box-inner">
      <c-title slot="header" title="个人资料" :back="false"></c-title>
      <div class="div-scroll">
        <div class="tips-container">
          <div class="tips">
            <div class="title">
              <i class="el-icon-info"></i><span>温馨提示</span>
            </div>
            <p>1、请在填报周期内完成以下信息录入；</p>
            <p>2、烦请各位同学在补充个人信息之后，再进行学年鉴定申请；</p>
<!--            <p>2、填报完成后才可进行后续网报工作；</p>-->
<!--            <p>注：填写的内容将纳入个人档案，请谨慎填写确保信息真实有效。</p>-->
          </div>
        </div>
        <div class="predicted-list">
          <div
            class="pre-item"
            v-for="(item, index) in predictedList"
            :key="item.id"
            @click="goto(item)"
          >
            <img
              :src="
                require('../../../../../assets/images/prediect/status_' +
                  item.isComplete +
                  '.png')
              "
              class="status-img"
            />
            <div class="item-index">
              <img
                :src="
                  require('../../../../../assets/images/prediect/' +
                    (index + 1) +
                    '.png')
                "
                alt=""
                class="index-img"
                :class="{ first: index == 0 }"
              />
              <!-- <img
                :src="
                  require('../../../../assets/images/prediect/' +
                    item.icon +
                    '.png')
                "
                alt=""
                class="icon"
              /> -->
            </div>
            <div class="item-left">
              <p class="title ellipsis">{{ item.name }}</p>
              <p class="ellipsis">{{ item.brief }}</p>
              <p class="ellipsis">
                <span
                  >状态：<span
                    :class="{
                      grey: item.status == 0,
                      green: item.status == 1,
                      red: item.status == 2,
                    }"
                    >{{
                      item.status == 0
                        ? "未开始"
                        : item.status == 1
                        ? "进行中"
                        : "已结束"
                    }}</span
                  ></span
                >
              </p>
              <p class="ellipsis">
                距离结束时间：<span class="red">{{
                  item.lastTime || "--"
                }}</span>
              </p>
            </div>
            <div class="item-right">
              <!-- 0未完成 1已完成 2驳回 3审核通过 4审核中 -->
              <el-button
                type="primary"
                v-if="item.status == 1 && item.isComplete == 0"
                size="small"
                >去填报</el-button
              >
              <el-button
                type="primary"
                v-else-if="item.status == 1 && item.isComplete == 1"
                size="small"
                >修改</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      predictedList: [],
      isPay: false,
      isNeedExchange: false, // 是否必须换专业
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {
    this.getPredictedList();
  },
  mounted() {},
  methods: {
    goto(data) {
      // 0未完成 1已完成 2驳回 3审核中 4审核通过  5已拒绝
      // 0,1,2可跳转编辑
      // console.log(data);
      if (data.status == 0) {
        return this.$message.warning(`该事项暂未开始！`);
      }
      // else if (data.status == 2) {
      //   return this.$message.warning(`该事项已结束！`);
      // }
      else {
        this.pushRoute(data);
      }
    },

    // 跳转路由
    pushRoute(data) {
      console.log(data);
      if (data.url) {
        this.$router.push(data.url + "/" + data.status);
      }
    },
    getPredictedList() {
      this.$http
        .get("/account/base/student/config/myInfo")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            if (res.data) {
              let data = res.data;
              data.forEach((item) => {
                if (item.status == 1) {
                  let t1 = new Date().getTime();
                  let t2 = new Date(item.endTime).getTime();
                  //计算时间差并转换成标准时间单位
                  let dura = t2 - t1;
                  item.lastTime = this.formatDuring(dura);
                } else {
                  item.lastTime = null;
                }
              });
              this.predictedList = data;
            }
          } else {
            this.$message.error(`${res.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`${err}`);
        });
    },
    formatDuring(mss) {
      let times = mss / 1000;
      var d = parseInt(times / 60 / 60 / 24); // 天
      var h = parseInt((times / 60 / 60) % 24); //时
      var m = parseInt((times / 60) % 60); // 分
      return d + " 天 " + h + " 小时 " + m + "分";
    },
  },
};
</script>

<style lang="less" scoped>
.tips-container {
  padding-top: 20px;
  padding-left: 30px;
  .tips {
    margin-bottom: 15px;
    color: #787878;

    i.el-icon-info {
      vertical-align: middle;
      font-size: 18px;
      margin-right: 5px;
      color: #409eff;
    }

    .title {
      font-size: 16px;
      line-height: 30px;
      // padding-left: 25px;
      color: #5a5a5a;
    }

    p {
      text-indent: 2em;
      line-height: 26px;
    }
  }
}
</style>
